import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Pill, Utensils, CheckSquare, ShieldAlert, Search, Zap } from 'lucide-react';
import { SectionReveal } from '../ui/SectionReveal';
const deliverables = [{
  icon: BookOpen,
  title: 'La Guía Maestra PDF',
  desc: 'El protocolo completo de 7 días paso a paso.'
}, {
  icon: Pill,
  title: 'Plan de Suplementación Inteligente',
  desc: 'Dosis y horarios precisos para Berberina y Cromo.'
}, {
  icon: Utensils,
  title: 'El Método del Orden de Alimentos',
  desc: 'Cómo comer lo que te gusta minimizando el impacto glucémico.'
}, {
  icon: CheckSquare,
  title: 'Checklist de Seguimiento Diario',
  desc: 'Para que sepas exactamente qué hacer desde que despiertas hasta que duermes.'
}, {
  icon: ShieldAlert,
  title: 'Protocolo de Rescate',
  desc: 'Qué hacer en 15 minutos si experimentas un pico inesperado.'
}, {
  icon: Search,
  title: 'Glosario de Disparadores Invisibles',
  desc: 'Identifica qué factores (además de la comida) están subiendo tu azúcar.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 100
    }
  }
};
export function SolutionSection() {
  return <SectionReveal bgColor="white" data-id="element-174">
      <div className="max-w-5xl mx-auto" data-id="element-175">
        {/* Mechanism Intro */}
        <div className="text-center mb-16" data-id="element-176">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#0D6E6E]/10 text-[#0D6E6E] mb-6" data-id="element-177">
            <Zap className="w-8 h-8" data-id="element-178" />
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#1A1A2E] mb-6" data-id="element-179">
            Presentamos el{' '}
            <span className="text-[#0D6E6E]" data-id="element-180">Plan 7D Control</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed" data-id="element-181">
            A diferencia de otros planes, este sistema no se basa en la
            restricción total, sino en la{' '}
            <strong className="text-[#1A1A2E]" data-id="element-182">estabilización acelerada</strong>
            . Combinamos el orden estratégico de los alimentos (qué comer
            primero para reducir el pico en un 30%) con el uso preciso de 4
            aliados naturales: Berberina, Canela de Ceilán, Picolinato de Cromo
            y Melón Amargo.
          </p>
          <p className="text-xl font-bold text-[#D4A017] mt-6" data-id="element-183">
            En solo una semana, reprogramamos la respuesta de tu cuerpo ante la
            comida.
          </p>
        </div>

        {/* What You Get Grid */}
        <div className="bg-[#FAFAFA] rounded-3xl p-8 md:p-12 border border-gray-200" data-id="element-184">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-[#1A1A2E] mb-12" data-id="element-185">
            Todo lo que recibes hoy:
          </h3>

          <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-186">
            {deliverables.map((item, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-all hover:-translate-y-1" data-id="element-187">
                <div className="w-12 h-12 rounded-xl bg-[#F0FDF4] flex items-center justify-center mb-6" data-id="element-188">
                  <item.icon className="w-6 h-6 text-[#10B981]" data-id="element-189" />
                </div>
                <h4 className="text-lg font-bold text-[#1A1A2E] mb-3 leading-tight" data-id="element-190">
                  {item.title}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-191">
                  {item.desc}
                </p>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </SectionReveal>;
}